import { render, staticRenderFns } from "./estadisticas-inicio-venta-actual.vue?vue&type=template&id=726ab573&scoped=true&"
import script from "./estadisticas-inicio-venta-actual.vue?vue&type=script&lang=ts&"
export * from "./estadisticas-inicio-venta-actual.vue?vue&type=script&lang=ts&"
import style0 from "./estadisticas-inicio-venta-actual.vue?vue&type=style&index=0&id=726ab573&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726ab573",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow,VSkeletonLoader,VSpacer})


/* vuetify-loader */
import installDirectives from "!../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
